export default __webpack_public_path__ + "static/media/ic-announcements-text.ed7aa182.svg";